import React from 'react';
import Config from './../../Config'
const { ReactCaptcha } = Config()


class Captcha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            captchaVisible: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isShowCaptcha != this.props.isShowCaptcha && this.props.isShowCaptcha == true) {
            if (this.Captcha && this.props.isShowCaptcha) {
                this.setState({
                    captchaVisible: true
                })
                this.Captcha.getCaptchaInfo(this.props.userName || '');
            }
        }
    }

    closeCaptcha() {
        this.setState({
            captchaVisible: false,
        }, () => {
            typeof this.props.onSubmit == 'function' && this.props.onSubmit('close')
        });
    };


    onMatch() {
        this.setState({
            captchaVisible: false,
        }, () => {
            typeof this.props.onSubmit == 'function' && this.props.onSubmit('submit')
        })
    }

    render() {
        return <ReactCaptcha
            captchaVisible={this.state.captchaVisible}
            visible={this.state.captchaVisible}

            onMatch={this.onMatch.bind(this)}

            getCaptchaInfo={(props) => {
                this.Captcha = props;
            }}

            close={this.closeCaptcha.bind(this)}
            setCaptchaVisible={(v) => {
                this.setState({ captchaVisible: v });
            }}
        />
    }

};

export default Captcha;